const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
const observedElements = new WeakSet();
const sectionSelectors = [
  ".section-resource-list__header",
  ".media-with-content",
  ".moon-hoard-collection-guide__header",
  ".moon-hoard-about__section-heading",
];
const cardSelectors = [
  ".moon-hoard-world-card",
  ".product-card",
  ".featured-blog-posts-card",
  ".moon-hoard-collection-guide__questions article",
];

const show = (element) => element.classList.add("is-visible");

const observer =
  !reducedMotion.matches && "IntersectionObserver" in window
    ? new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            show(entry.target);
            observer.unobserve(entry.target);
          }
        },
        { threshold: 0.12 },
      )
    : null;

const prepareMotion = (root = document) => {
  for (const element of root.querySelectorAll(sectionSelectors.join(","))) {
    if (element.hasAttribute("data-moon-hoard-reveal")) continue;
    element.dataset.moonHoardReveal = "";
    element.setAttribute("data-moon-motion", "section-enter");
  }

  for (const [index, element] of root
    .querySelectorAll(cardSelectors.join(","))
    .entries()) {
    element.dataset.moonHoardReveal = "";
    element.setAttribute("data-moon-motion", "card-stagger");
    element.style.setProperty(
      "--moon-hoard-reveal-delay",
      `${Math.min(index % 5, 4) * 70}ms`,
    );
  }
};

const initializeReveals = (root = document) => {
  prepareMotion(root);
  for (const element of root.querySelectorAll("[data-moon-hoard-reveal]")) {
    if (observedElements.has(element)) continue;
    observedElements.add(element);
    if (observer) observer.observe(element);
    else show(element);
  }
};

initializeReveals();

document.addEventListener("shopify:section:load", (event) => {
  initializeReveals(event.target);
});
